import React from 'react';
import { Leaf, Users, Trees, Lightbulb } from 'lucide-react';

const ImpactCard = ({ icon: Icon, title, items }) => {
  return (
    <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300">
      <div className="w-14 h-14 bg-emerald-50 rounded-xl flex items-center justify-center mb-6">
        <Icon className="w-7 h-7 text-emerald-700" />
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-4">{title}</h3>
      <ul className="space-y-3">
        {items.map((item, index) => (
          <li key={index} className="flex items-start gap-3">
            <div className="w-1.5 h-1.5 bg-emerald-600 rounded-full mt-2 flex-shrink-0" />
            <span className="text-gray-600 leading-relaxed">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Sustainability = () => {
  const impacts = [
    {
      icon: Leaf,
      title: 'Environmental Impact',
      items: [
        'Reduction in fossil fuel dependency',
        'Lower carbon emissions',
        'Contribution to India\'s renewable targets',
        'Sustainable land usage practices'
      ]
    },
    {
      icon: Users,
      title: 'Social Impact',
      items: [
        'Local employment during construction',
        'Infrastructure development',
        'Community engagement programs',
        'Responsible land usage'
      ]
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Sustainability & Impact</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            TenSolar's mission goes beyond power generation
          </p>
        </div>

        {/* Impact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {impacts.map((impact, index) => (
            <ImpactCard key={index} {...impact} />
          ))}
        </div>

        {/* Statistics Banner */}
        <div className="bg-gradient-to-r from-emerald-700 to-emerald-600 rounded-2xl p-12 text-white text-center">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <Trees className="w-10 h-10 mx-auto mb-3 opacity-90" />
              <div className="text-3xl font-bold mb-2">12,000+</div>
              <div className="text-emerald-100">Tonnes CO₂ Reduced Annually</div>
            </div>
            <div>
              <Lightbulb className="w-10 h-10 mx-auto mb-3 opacity-90" />
              <div className="text-3xl font-bold mb-2">10 MW</div>
              <div className="text-emerald-100">Clean Energy Generation</div>
            </div>
            <div>
              <Users className="w-10 h-10 mx-auto mb-3 opacity-90" />
              <div className="text-3xl font-bold mb-2">100+</div>
              <div className="text-emerald-100">Jobs Created</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sustainability;
